import type { IdentitySession } from "@app/vue/providers/Auth";

/**
 * The shops a group dashboard reports on: those where the identity manages the
 * POS, or every shop for a viewer, who has no POS personas by design. Mirrors
 * the scope get_group_overview / get_group_revenue_over_time enforce.
 */
export const reportingShops = <T extends { pos_role: string | null }>(
  shops: T[],
  groupRole: IdentitySession["group_role"],
): T[] =>
  groupRole === "viewer"
    ? shops
    : shops.filter((shop) => shop.pos_role === "manager");
